import "./NotFound.css";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import NotFoundImage from '../../assets/images/404_desktop.webp';
import { useState } from "react";

const NotFound = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div className="not_found_page">
      <div className="not_found_page_content">
		<div className="not-found__heading">
			<div className="title_large title_not_found">
			ARE YOU { window.innerWidth < 1100 && <br></br>}{" "}
			<span className="title_word_background_line_wrapper">
				{" "}
				<span className="title_word_background_line"></span>EXPLORING THE UNKNOWN?
			</span>
			</div>
		</div>
      
		<div className="not_found__img_wrapper">
			<img className="not_found__img" src={NotFoundImage} alt="404 image" />
		</div>
		<div className="not_found__text_wrapper">
			<div className="not_found__subtitle">OOPS, YOU'VE GONE OFF THE MAP!</div>
			<p className="not_found__info">It looks like you've stumbled into uncharted territory! Even our most adventurous urban planners haven't mapped this area of Cotown. While we work on expanding our city limits, let's guide you back to known territory. the button below to return to safety and continue crafting your dream city!</p>
			<button onClick={() => navigate('/')} className="not_found__back_btn">Get Back to CoTown</button>
		</div>
      </div>
    </div>
  );
};

export default NotFound;
